'use strict';
import React, { Component } from 'react';
import { GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';

class Titulo extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return <div>
            <div className="row top-separator-xs">
                <div className="col-md-6">
                    <h4>{this.props.titulo}</h4>
                </div>
                <div className="col-xs-3">
                    <h4>{this.props.segundoTitulo}</h4>
                </div>
                <div className="col-md-3 text-right">
                    {this.props.mostrarBoton ?
                        <button className="btn btn-cta2" type="button" onClick={() => props.goToVerResumen()}>{this.props.lblBoton}</button> : ""}
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <hr className="separator-line separator-light" />
                </div>
            </div>
        </div>
    }
}
export default Titulo;